import { render, staticRenderFns } from "./mark-list.vue?vue&type=template&id=219c66b9&"
import script from "./mark-list.vue?vue&type=script&lang=ts&"
export * from "./mark-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports